import { getMyActiveTickets, getRetrievalQueue } from '@jq4race/api-client';
import { useQuery } from '@tanstack/react-query';

export const RETRIEVAL_QUEUE_KEY = ['retrieval-queue'] as const;
export const MY_ACTIVE_KEY = ['my-active'] as const;

// Adversarial-review fix (Slice 3, finding #1): NEITHER of these queries is
// allowlisted for offline persistence anymore — their items carry customer
// data (plate, qrTag, zone, paymentStatus) that must never be readable,
// unauthenticated, from the offline-shell branch. `networkMode:'offlineFirst'`
// was removed along with the allowlist entry — these queries use TanStack
// Query's default 'online' networkMode, same as every other non-offline
// query in the app.

export function useRetrievalQueue() {
  return useQuery({
    queryKey: RETRIEVAL_QUEUE_KEY,
    queryFn: getRetrievalQueue,
  });
}

export function useMyActiveTickets() {
  return useQuery({
    queryKey: MY_ACTIVE_KEY,
    queryFn: getMyActiveTickets,
    // JQ4-39 S6 (REQ-S6-03): poll every 8s so the valet sees "Paid" within 10s
    // after the Stripe webhook flips paymentStatus — without a manual reload.
    refetchInterval: 8000,
  });
}
